export default class MotionScroll {
  constructor(el) {
    this.el = el
    this.target = 0
    this.targetDelta = 0
    this.isMoving = false
  }

  update() {
    this.targetDelta = this.target - this.el.scrollLeft

    if (Math.abs(this.targetDelta) < 5) {
      this.el.scrollLeft = this.target
      this.isMoving = false
      return
    }

    this.isMoving = true
    this.el.scrollLeft += this.targetDelta * 0.1

    if (this.isMoving) requestAnimationFrame(() => { this.update() })
  }

  move(target) {
    this.target = Math.max(Math.min(target, this.el.scrollWidth - this.el.offsetWidth), 0)

    if (!this.isMoving) requestAnimationFrame(() => { this.update() })
  }

  append(value) {
    this.move(this.el.scrollLeft + value)
  }

  next() {
    this.append(this.el.offsetWidth)
  }

  previous() {
    this.append(-this.el.offsetWidth)
  }

  destroy() {
    this.isMoving = false
  }
}